import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import Images from 'assets/images/imageData';
import Loader from 'components/sales/Loader/loader';
import  './layout.css'
const Layout = ({
  children,
  title,
  isGoback,
  history,
  className,
  Buttons2 = null,
  Buttons = null,
  isLoading = false,
  status,
  linkFlag = false,
  linkUrl = '#',
  pagination = true,
  style = {},
  useNewHeaderLayout = false,
}) => {
  const contentWrapperClass = `content-wrapper ${className || ''} ${useNewHeaderLayout ? 'layout-new-header' : ''}`.trim();

  const headerContent = useNewHeaderLayout ? (
    <div className="layout-header-row">
      <h4 className="back-btn-sizes layout-header-title-text">
        {isGoback ? (
          <Link to={linkUrl} onClick={() => !linkFlag && history.goBack()} className="layout-header-title-link">
            <img src={Images?.BackArrowBlack} alt="" className="layout-header-back-arrow" />
            <span className="layout-header-title-label">{title}</span>
          </Link>
        ) : (
          <span className="layout-header-title-label">{title}</span>
        )}
      </h4>
      <div className="layout-header-actions-tile">
        {status && (
          <span className={`status-td ${status === 'In Progress' ? 'warm' : status === 'Not Started' ? 'cold' : status === 'Completed' ? 'completed' : ''}`}>
            {status}
          </span>
        )}
        {Buttons2 && Buttons2()}
        {Buttons && Buttons()}
      </div>
    </div>
  ) : (
    <>
      <div>
        <h4 className="back-btn-sizes">
          {isGoback ? (
            <Link to={linkUrl} onClick={() => !linkFlag && history.goBack()}>
              <img src={Images?.BackArrowBlack} alt="" />
              {title}
            </Link>
          ) : (
            <span>{title}</span>
          )}
        </h4>
      </div>
      <div className="btn-group">
        <div className="d-none d-md-inline-block">
          {status && (
            <span className={`status-td ${status === 'In Progress' ? 'warm' : status === 'Not Started' ? 'cold' : status === 'Completed' ? 'completed' : ''}`}>
              {status}
            </span>
          )}
          {Buttons2 && Buttons2()}
          {Buttons && Buttons()}
        </div>
      </div>
    </>
  );

  return (
    <Fragment>
      <div className={contentWrapperClass}>
      
       
        <div className="layout-header">
          {headerContent}
        </div>
        <div
          className={
            pagination
              ? 'panel scrollbar-styling pagination pagination1 pr-pagination combo'
              : 'panel scrollbar-styling combo'
          }
          style={style}
        >
          {useNewHeaderLayout ? (
            <div className="panel-inner-scroll scrollbar-styling">
              {children}
            </div>
          ) : (
            children
          )}
        </div>
        <div className={`btn-group ${useNewHeaderLayout ? 'layout-footer-actions' : ''}`}>
          <div className="d-md-none d-block pr-btn xs-fullwidth">
          <div className="pr-btn poc-btn">
          <b className="Mf-btn">
          {Buttons2 && Buttons2()}
            {Buttons && Buttons()}
          </b>
            </div>
        </div>
        </div>
      </div>
     
      <Loader isLoading={isLoading} />
    </Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.any,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  isGoback: PropTypes.bool,
  history: PropTypes.object,
  className: PropTypes.string,
  Buttons: PropTypes.func,
  useNewHeaderLayout: PropTypes.bool,
};

export default withRouter(Layout);
